import { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { globalTheme } from '@clds/component-theme';
import { useSelectedAsset, usePurchaseInfo, useProducts } from '../../getty-selectors';
import Plan from './Plan';
import Format from './Format';
import Summary from './Summary';

const PreviewBox = styled.div`
  background: ${globalTheme.palette.surface};
  box-shadow: ${globalTheme.shadow.md};
  flex-grow: 1;
  z-index: 2;
  overflow: auto;
  width: 45%;
`;

export default ({ source, actions }) => {
  const dispatch = useDispatch();
  const { selectedAsset, selectedFormat } = useSelectedAsset(source);
  const { selectedProduct } = useProducts(source);
  const { isAssetIncludedInProduct, isAlreadyPurchased } = usePurchaseInfo(source);
  const { handleSelectAssetFormatAction, handleSelectProductAction } = actions;

  const handleSelectAssetFormat = useCallback(
    (payload) => {
      dispatch(handleSelectAssetFormatAction(payload));
    },
    [dispatch, handleSelectAssetFormatAction]
  );

  return (
    <PreviewBox>
      {!isAlreadyPurchased && <Plan source={source} selectedAsset={selectedAsset} handleSelectProductAction={handleSelectProductAction} />}
      {(isAlreadyPurchased ||
        (selectedProduct?.exceeded === false &&
          isAssetIncludedInProduct &&
          ((selectedAsset.creditPrice < selectedProduct?.creditsRemaining && selectedProduct?.type === 'creditpack') ||
            (selectedProduct?.type !== 'creditpack' && selectedProduct.downloadsRemaining > 0)))) && (
        <Format selectedAsset={selectedAsset} selectedFormat={selectedFormat} selectAssetFormat={handleSelectAssetFormat} source={source} />
      )}
      <Summary selectedAsset={selectedAsset} selectedProduct={selectedProduct} source={source} />
    </PreviewBox>
  );
};
